module.exports = __webpack_public_path__ + "img/send-syntax.0fca276a.png";